import React from 'react';
import Home from './Home';
import { CssBaseline } from '@mui/material';

function App() {
  return (
    <>
      <CssBaseline />
      <Home />
    </>
  );
}

export default App;